<template>
  <div>
    <KTCodePreview v-bind:title="'In Hoá đơn dịch vụ'">
      <template v-slot:toolbar>
        <b-button
          variant="primary"
          size="sm"
          class="font-weight-bolder"
          @click="onClickToPrint"
          :disabled="!renderComponent"
        >
          <i
            style="font-size: 1rem"
            class="fas fa-print"
          ></i>In hoá đơn dịch vụ
        </b-button>
      </template>
      <template v-slot:preview>
        <hr
          class="hr-text"
          data-content="Khổ giấy A5"
          style="font-weight: 600"
        />
        <div
          id="repair-bill-area"
          v-if="renderComponent"
        >
          <PrintRepairBill
            :slip="slip"
            :bill="bill"
          />
        </div>
        <br />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { TIME_TRIGGER } from '@/utils/constants';
import { makeToastFaile } from '@/utils/common';
import PrintRepairBill from '@/view/components/warranty-service/PrintRepairBill.vue';

export default {
  name: 'PrintRepairBillPage',
  components: {
    KTCodePreview,
    PrintRepairBill,
  },
  data() {
    return {
      slip: {},
      bill: null,
      renderComponent: false,
    };
  },
  async created() {
    const id = this.$route.query.id || this.$route.params.id;
    if (!id) {
      makeToastFaile('Thiếu mã phiếu');
      return;
    }
    await this.getRepairSlip(id);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Dịch vụ bảo hành', route: '/warranty-service/repair-slips' },
      { title: 'In hoá đơn dịch vụ' },
    ]);
  },
  methods: {
    async getRepairSlip(id) {
      this.renderComponent = false;
      try {
        const { data } = await ApiService.get(`v2/warranty-service/repair-slips/${id}`);
        this.slip = data && data.data ? data.data : {};
        const billNumber = this.slip.serviceBill && this.slip.serviceBill.billNumber;
        if (!billNumber) {
          makeToastFaile('Phiếu chưa có Hoá đơn dịch vụ liên kết');
          return;
        }
        await this.getBill(billNumber);
        this.renderComponent = true;
      } catch (err) {
        makeToastFaile(err && err.message ? err.message : 'Không tải được phiếu');
      }
    },
    async getBill(billNumber) {
      try {
        const { data } = await ApiService.get(`bills/${billNumber}`);
        this.bill = data && data.data ? data.data : null;
        if (!this.bill) {
          makeToastFaile('Không tải được hoá đơn dịch vụ');
        }
      } catch (err) {
        makeToastFaile(err && err.message ? err.message : 'Không tải được hoá đơn dịch vụ');
      }
    },
    printData(stylePrint) {
      const prtHtml = document.getElementById('repair-bill-area').innerHTML;
      let stylesHtml = '';
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open(
        '',
        '',
        'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0',
      );
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
            ${stylePrint}
          </head>
          <body>${prtHtml}</body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(() => {
        WinPrint.print();
      }, TIME_TRIGGER);
    },
    getStylePrint() {
      return `<style>
        @page { size: A5 portrait; margin: 8mm; }
        body { margin: 0; }
      </style>`;
    },
    onClickToPrint() {
      this.printData(this.getStylePrint());
    },
  },
};
</script>
